import useAudioIndicators from './useAudioIndicators';
import { Indicators } from '@round/whitelabel-ui';
import { SkeletonizedValue } from '@round/ui-kit';
import { formatNumberToKNotation } from '@round/utils';
import { numberWithCommas } from 'helpers';
import { Tooltip } from '@round/whitelabel-ui';
import RelativeValueLabel from '../../../components/RelativeValueLabel/RelativeValueLabel';

type Props = {
    audioId: number | null | undefined;
    className?: string;
};

const AudioIndicators = ({ audioId, className }: Props) => {
    const { indicators, status } = useAudioIndicators(audioId);

    return (
        <Indicators.Container className={className}>
            {indicators.map((indicator) => (
                <Indicators.Item key={indicator.label}>
                    <Indicators.Label>{indicator.label}</Indicators.Label>
                    <Tooltip.Root>
                        {(anchor, setAnchorRef) => (
                            <>
                                <Indicators.Value ref={setAnchorRef}>
                                    <SkeletonizedValue
                                        isInitialized={status === 'success' || status === 'error'}
                                        width="4rem"
                                    >
                                        {typeof indicator.value === 'number'
                                            ? formatNumberToKNotation(indicator.value)
                                            : '-'}

                                        {typeof indicator.relativeValue === 'number' ? (
                                            <RelativeValueLabel value={indicator.relativeValue} />
                                        ) : null}
                                    </SkeletonizedValue>
                                </Indicators.Value>

                                <Tooltip anchorElement={anchor} disabled={!indicator.value || indicator.value < 1000}>
                                    <Tooltip.Title>{indicator.label}</Tooltip.Title>
                                    <Tooltip.Body>
                                        {typeof indicator.value === 'number' ? numberWithCommas(indicator.value) : ''}
                                    </Tooltip.Body>
                                </Tooltip>
                            </>
                        )}
                    </Tooltip.Root>
                </Indicators.Item>
            ))}
        </Indicators.Container>
    );
};

export default AudioIndicators;
